import { all, call, fork, put, select, take } from 'redux-saga/effects';

import { CREATE_HIGHLIGHT } from './actions';
import { RESET_ANNOTATION } from 'Reducers/compModels';
import { SAVE_HIGHLIGHTS, SAVE_NOTES } from 'Reducers/dataModels';

import { highlightsAndNotes as nmHighlightsAndNotes } from 'Lib/normalizers';
import notebookFilterMarkers from 'Lib/notebookFilterMarkers';
import { createHighlight as vsCreateHighlight } from 'Services/learnkit';


function* create() {
  while (true) {
    const { data:{ markerId, noteText }}  = yield take(CREATE_HIGHLIGHT);

    const { highlights, notes } = yield select(state => {
      return {
        highlights: state.highlights,
        notes: state.notes
      };
    });
    const options = {
      markerId,
      noteText
    };

    const { highlight:vsHighlight } = yield call(vsCreateHighlight, options);
    const [nmHighlight, nmNote] = yield nmHighlightsAndNotes([vsHighlight]);

    const updatedHighlights = [...highlights, ...nmHighlight];
    const updatedNotes = [...notes, ...nmNote];

    yield fork(notebookFilterMarkers, updatedHighlights);

    yield all([
      put({ type: RESET_ANNOTATION }),
      put({ type: SAVE_HIGHLIGHTS, data: updatedHighlights }),
      put({ type: SAVE_NOTES, data: updatedNotes })
    ]);
  }
}


export default create;
